import React, { FC } from 'react'
import classNames from 'classnames'
import Fade from 'react-reveal/Fade'

import StylesModule from 'components/lv2/AnimeArea.module.scss'

export interface AnimeAreaProps {
  addClassName?: string
}

const AnimeArea: FC<AnimeAreaProps> = ({ children, addClassName }) => {
  addClassName = addClassName ? addClassName : ''
  return (
    <Fade bottom duration={1000} opposite distance="20px">
      <div
        className={classNames(
          StylesModule.animeArea,
          StylesModule[addClassName],
        )}
      >
        {children}
      </div>
    </Fade>
  )
}

export default AnimeArea
